module.exports = __webpack_public_path__ + "img/twitter.7ccee913.png";